import { render, staticRenderFns } from "./udTable.vue?vue&type=template&id=4c8bd7bd&scoped=true&"
import script from "./udTable.vue?vue&type=script&lang=js&"
export * from "./udTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bd7bd",
  null
  
)

export default component.exports